/**
 * Configurações de Features da Aplicação
 *
 * Este arquivo controla a visibilidade de features específicas da aplicação.
 * Futuramente, estas flags serão substituídas por configurações vindas da API.
 */

export const FEATURES = {
  /**
   * Controla a exibição do Banner Carousel na página inicial
   * @type {boolean}
   * @default false
   *
   * Quando true: Banner carousel será exibido na home
   * Quando false: Banner carousel ficará oculto
   *
   * TODO: Integrar com endpoint da API para configurações dinâmicas
   * Endpoint futuro: GET /api/companies/{companyKey}/features
   */
  SHOW_BANNER_CAROUSEL: false,

  /**
   * Pagamento online (rota unificada /online-payments; hoje InfinitePay)
   * @type {boolean}
   * @default false
   *
   * Ligue por loja com REACT_APP_FEATURE_ONLINE_PAYMENT=true no .env.
   * Mesmo ligada, a opção "Pagar online" só aparece quando a empresa tem uma
   * integração ativa no painel (GET /online-payments/availability → available=true).
   */
  ONLINE_PAYMENT: process.env.REACT_APP_FEATURE_ONLINE_PAYMENT === "true",

  /**
   * Outras features podem ser adicionadas aqui
   * Exemplos:
   * SHOW_WHATSAPP_BUTTON: true,
   * ENABLE_LOYALTY_PROGRAM: false,
   * SHOW_PROMOTIONS_BANNER: true,
   */
};

/**
 * Função helper para verificar se uma feature está ativa
 * @param {string} featureName - Nome da feature (chave do objeto FEATURES)
 * @returns {boolean} - true se feature está ativa, false caso contrário
 */
export const isFeatureEnabled = (featureName) => {
  return FEATURES[featureName] === true;
};

/**
 * Função para atualizar configurações via API (implementação futura)
 * @param {string} companyKey - Chave da empresa
 * @returns {Promise<Object>} - Configurações atualizadas da API
 *
 * Exemplo de uso futuro:
 * ```javascript
 * const config = await fetchFeaturesConfig('af60df41-0ac0-4f92-ab1d-52ad8d27a262');
 * // config = { SHOW_BANNER_CAROUSEL: true, ... }
 * ```
 */
export const fetchFeaturesConfig = async (companyKey) => {
  // TODO: Implementar chamada real à API
  // const response = await fetch(`/api/companies/${companyKey}/features`);
  // const data = await response.json();
  // return data;

  console.warn(
    "fetchFeaturesConfig: Função ainda não implementada. Usando configurações locais."
  );
  return FEATURES;
};
